module.exports = __webpack_public_path__ + "img/icon_no-results.80bc3994.svg";